<template>
  <div>
    <b-overlay :show="loading || parentLoading">
      <!-- <b-row>
        <b-col cols="12" md="12" v-if="showAlert">
          <b-alert show variant="primary" v-html="alertText" />
        </b-col>
      </b-row> -->
      <b-row
        v-if="showRoleSelected && roleSelected.length"
        class="mx-0 py-2 px-3"
      >
        <b-col cols="12" md="12" class="px-0">
          <strong v-text="`${$lang.selected_roles}: `" />
        </b-col>
        <b-col
          cols="12"
          md="auto"
          class="p-1"
          v-for="item in roleSelected"
          :key="item.code"
        >
          <div
            class="
              bg-light
              p-2
              rounded
              d-flex
              align-items-center
              justify-content-between
            "
          >
            <span v-text="item.caption" />
            <a class="text-danger cursor_pointer" @click="removeTag(item)"
              ><i class="fas fa-times fa-lg ml-3"
            /></a>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="usedInForm" class="mx-0">
        <b-col
          cols="12"
          md="12"
          class="
            bg-info
            text-white
            d-flex
            align-items-center
            justify-content-between
            py-2
          "
        >
          <span
            v-text="'جهت نمایش، ویرایش نقش‌ها روی دکمه روبرو کلیک نمایید'"
          />
          <b-button
            variant="light"
            size="sm"
            class="
              d-flex
              align-items-center
              justify-content-between
              font-weight-bold
            "
            @click="showSelectRoleBox = !showSelectRoleBox"
          >
            <span
              v-text="
                showSelectRoleBox
                  ? 'بستن انتخاب نقش‌ها'
                  : 'بازکردن انتخاب نقش‌ها'
              "
            />
            <mdicon
              :name="`chevron-double-${showSelectRoleBox ? 'up' : 'down'}`"
              size="20"
            />
          </b-button>
        </b-col>
        <b-col
          v-if="showSelectRoleBox"
          cols="12"
          md="12"
          class="bg-light list_style_reset pt-3"
        >
          <b-alert :show="showAlert" variant="primary" v-html="alertText" />
          <tree-folder
            :folder="items"
            :dynamicButton="dynamicButton"
            @methodOnClick="methodOnClick"
            @getData="getData"
            @select="select"
          />
        </b-col>
      </b-row>
      <div v-else class="tree bg-white">
        <tree-folder
          :folder="items"
          :dynamicButton="dynamicButton"
          @methodOnClick="methodOnClick"
          @getData="getData"
          @select="select"
        />
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  props: {
    dynamicButton: {
      type: [Object, Array],
    },
    showAlert: {
      type: Boolean,
      default: true,
    },
    showAlertNotice: {
      type: Boolean,
      default: true,
    },
    showRoleSelected: {
      type: Boolean,
      default: false,
    },
    tags: {
      type: Array,
      default: () => [],
    },
    refreshRole: {
      type: Boolean,
      default: false,
    },
    parentLoading: {
      type: Boolean,
      default: false,
    },
    limitSelected: {
      type: [String, Number],
      default: null,
    },
    generateRoleSelected: {
      type: Boolean,
      default: false,
    },
    usedInForm: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: {},
      roleSelected: [],
      loading: false,
      showSelectRoleBox: false,
    };
  },
  computed: {
    alertText() {
      let content = this.$lang.role_selected_alert;

      if (this.showAlertNotice) {
        content += `<br /><small class='text-danger font-weight-bold'>
                <i class='fas fa-info-circle mr-1'></i>
                ${this.$lang.role_selected_alert_notice}
              </small>`;
      }

      return content;
    },
  },
  watch: {
    refreshRole(value) {
      /* guidance: refresh data with parent component */
      // value && this.fetchData();
    },

    generateRoleSelected(value) {
      /* guidance: regenerate role selected with parent component */
      value && this.mergeRoleSelected();
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    generateApiUrl,
    methodOnClick(item, type) {
      this.$emit("methodOnClick", item, type, () => this.getData2(item, type));
    },
    async getRoles(parent_code = null, rewriteItems = true) {
      try {
        this.loading = true;
        const queryString = parent_code
          ? {
              parent_code,
              show_all_node: 1,
              order_by: "id:asc",
            }
          : {
              show_all_node: 1,
              order_by: "id:asc",
            };
        let url = generateApiUrl(["resources", "role_tree"], [], queryString);
        const response = await this.$httpService.get(url);
        const roles = pathOr([], ["data", "data"], response);
        roles.icon = "";
        roles.name = roles.caption;
        const children = roles.children.map((child) => {
          return {
            ...child,
            name: child.caption,
            children: [],
            load_children: true,
          };
        });
        roles.children = children.map((x) => {
          return {
            ...x,
            parent_name: roles.caption,
          };
        });
        if (rewriteItems) {
          this.items = { ...roles };
        }
        return roles;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    getTypeKey(type) {
      switch (type) {
        case "add":
          return "code";
        case "edit":
          return "code";
        case "delete":
          return "all";
        case "clone":
          return "code";
        case "permissions":
          return "code";
        case "sync":
          return "code";
        default:
          return "code";
      }
    },
    async getData(item, type = null) {
      const itemChildren = pathOr([], ["children"], item);
      if (type || !itemChildren.length) {
        const roles = await this.getRoles(item.code, false);
        const children = pathOr([], ["children"], roles);
        if (children.length) {
          item.children = children.map((child) => {
            return {
              ...child,
              name: child.caption,
              load_children: true,
              parent_name: item.name,
              children: [],
            };
          });
          item.load_children = false;
        }
      }
    },
    async getData2(item, type = null) {
      if (type) {
        if (type === "delete") {
          await this.fetchData();
          return;
        }
        const code = pathOr(null, [this.getTypeKey(type)], item);
        const roles = await this.getRoles(code, false);
        item.name = pathOr(item.caption, ["caption"], roles);
        item.has_child = pathOr(false, ["has_child"], roles);
        const children = pathOr([], ["children"], roles);
        if (children.length) {
          item.children = children.map((child) => {
            return {
              ...child,
              name: child.caption,
              load_children: true,
              parent_name: item.name,
              children: [],
            };
          });
          item.load_children = false;
        }
      }
    },
    select(item) {
      /* guidance: check limit select role */
      if (
        this.limitSelected &&
        this.roleSelected.length >= this.limitSelected
      ) {
        return this.$notify.warning(
          `شما فقط امکان انتخاب ${this.limitSelected} نقش را دارید`
        );
      }

      /* guidance: check repeat select role */
      if (this.roleSelected.find((x) => x.code === item.code)) {
        return this.$notify.warning(
          `نقش ${item.caption} را قبلا انتخاب کرده اید`
        );
      }

      /* guidance: check select primary role */
      if (this.items.code === item.code) {
        return this.$notify.warning(
          `شما مجاز به دادن نقش خود(${this.items.caption}) به کاربر دیگری نیستید.`
        );
      }

      const { code, caption } = item;
      this.roleSelected.push({ code, caption });
      this.$emit("updateRoleSelected", this.roleSelected);
    },
    removeTag(item) {
      const index = this.roleSelected.indexOf(item);
      this.roleSelected.splice(index, 1);
      this.$emit("updateRoleSelected", this.roleSelected);
    },
    mergeRoleSelected() {
      this.roleSelected = [...new Set([...this.roleSelected, ...this.tags])];
    },
    async fetchData() {
      await this.getRoles();
      this.mergeRoleSelected();
      this.$emit("updateRefreshRole", false);
    },
  },
};
</script>

<style>
.tree {
  padding: 10px 0;
  width: 100%;
  /* margin: 10px; */
}

.tree ul {
  list-style-type: none;
  margin: 0;
  padding-right: 0;
  color: #444;
  font-size: 14xp;
  /* font-family: 'Segoe Ui', sans-serif !important; */
  /* font-family: "Font Awesome 5 Free"; */
  perspective: 300px;
  perspective-origin: left;
}

.folder > li > span {
  font-weight: bold;
  cursor: pointer;
  width: 100%;
}

.contents {
  padding-right: 20px !important;
}

.contents > li {
  position: relative;
  padding-right: 5px;
}

.contents > li::before {
  position: absolute;
  content: "";
  right: -10px;
  display: inline-block;
  width: 2px;
  height: 100%;
  background-color: #dedede;
}

.contents > li:last-child::before {
  height: 13px;
}

.contents > li::after {
  position: absolute;
  content: "";
  right: -9px;
  top: 12px;
  display: inline-block;
  width: 10px;
  height: 2px;
  background-color: #dedede;
}

ul.folder {
  position: relative;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease-out;
  overflow: hidden;
}

.fade-enter {
  transform: translateZ(100px);
  opacity: 0;
}

.fade-leave-to {
  transform: translateZ(-100px);
  opacity: 0;
}

/* .tree-icon {
    display: block;
    display: flex;
    font-family: FontAwesome;
    font-style: normal;
    font-weight: normal;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  } */

.folder > li > span::before,
.contents > li > span::before {
  margin-left: 5px;
  font-weight: bold;
}

.folder > li > span::before {
  color: rgb(250, 223, 135);
}

.contents > li > span::before {
  color: #dedede;
}

.folder > li > span.close-folder::before {
  content: "\f65e";
  float: right;
}

.folder > li > span.open-folder::before {
  content: "\f65e";
  float: right;
}
.folder > li > span.open-folder::before {
  content: "\f65e";
  float: right;
}

.contents > li > span::before {
  content: "\f65e";
  float: right;
}

.showme {
  display: none;
  cursor: pointer;
}

.showhim:hover .showme {
  display: inline-block;
}
</style>
